import fetch from '../utils/fetch'

export function commonSearchAPI(country, data) {
    return fetch({
        url:  '/' + country + '/search',
        method: "get",
        params: data,
    })
}

// 议会数据详情
export function detailAPI(country, data) {
    // [
    //     major_heading_name: xxxx,
    //     first_level_paras: [
    //         {
    //             minor_heading_name: xxxx,
    //             second_level_paras: [
    //                 {
    //                     speech_id: xxxx,
    //                     speaker_name: xxxx,
    //                     contents: [ xxx, xxx, ... ],
    //                 },
    //                 ...
    //             ],
    //         }
    //     ],
    // ]
    
    return fetch({
        url:  '/' + country + '/search/detail',
        method: "get",
        params: data,
    })
}

// 议会数据下载
export function downloadAPI(data) {
    return fetch({
        url:  '/file/download',
        method: "post",
        params: data,
    })
}